import { Button, styled } from "@mui/material";

const BlueButtonStyled = styled(Button)({
    textTransform: 'none',
    fontSize: 16,
    padding: '9px 15px',
    border: '1px solid',
    borderRadius: '6px',
    boxShadow: '0px 4px 7px 2px rgba(46, 169, 132, 0.1)',
    lineHeight: '19px',
    fontWeight: '500',
    color: '#fff',
    backgroundColor: '#405289',
    borderColor: '#405289',
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:hover': {
      backgroundColor: '#222C4B',
      borderColor: '#222C4B',
    },
    '&:active': {
      backgroundColor: '#222C4B',
      borderColor: '#222C4B',
    },
    '&:focus': {
      // boxShadow: '0 0 0 0.2rem rgba(22,75,57,.5)',
    },
  });

  export default BlueButtonStyled;